"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LibraryPresetCard = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var styles = __importStar(require("./LibraryPresetCard.css"));
var LibraryPresetCard = function (_a) {
    var className = _a.className, theme = _a.theme, heading = _a.heading, description = _a.description, disabled = _a.disabled, disabledReason = _a.disabledReason, onClick = _a.onClick, footer = _a.footer, tooltipText = _a.tooltipText;
    var getTooltipProps = function () {
        if (disabled && disabledReason) {
            return { content: "", size: kaleidoscope_1.TooltipSize.Large };
        }
        else if (tooltipText) {
            return { content: tooltipText, size: kaleidoscope_1.TooltipSize.Small };
        }
        return undefined;
    };
    return (react_1.default.createElement(kaleidoscope_1.Card, { className: (0, classnames_1.default)(styles.wrapper({ theme: theme }), className) },
        react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.content, gap: "m" },
            react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.header, direction: "horizontal", justify: "spaceBetween", align: "start", gap: "m" },
                react_1.default.createElement(kaleidoscope_1.Heading, { className: styles.heading, level: "4", strong: true }, heading),
                react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.Add, null), isRound: true, type: kaleidoscope_1.ButtonType.Secondary, size: kaleidoscope_1.ButtonSize.Small, onClick: onClick, disabled: disabled, disabledReason: disabledReason, tooltip: getTooltipProps() })),
            description && (react_1.default.createElement(kaleidoscope_1.Text, { className: styles.body, size: "s" }, description)),
            footer && react_1.default.createElement("div", { className: styles.footer }, footer))));
};
exports.LibraryPresetCard = LibraryPresetCard;
